<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'积分下发':'积分下发'" :visible.sync="dialog" @close="unShowClick()" width="30%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="区号" :label-width="formLabelWidth">
					<el-select style="width: 100%;" v-model="areaCode" placeholder="请选择区号">
						<el-option key="+86" label="+86" value="+86">
						</el-option>
						<el-option key="+886" label="+886" value="+886">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户手机号" prop="user_uuid" :label-width="formLabelWidth">
					<el-select style="width: 100%;" v-model="addBody.user_uuid" @change="changeUser" filterable remote
						reserve-keyword placeholder="请输入用户手机号" :remote-method="remoteMethod" :loading="loading">
						<el-option v-for="item in options" :key="item.uuid" :label="item.phone" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户昵称" prop="name" :label-width="formLabelWidth">
					<el-input style="width: 100%;" v-model="addBody.name" disabled placeholder="请输入用户昵称"></el-input>
				</el-form-item>
				<el-form-item label="下发积分" prop="score" :label-width="formLabelWidth">
					<el-input style="width: 100%;" type='number' v-model="addBody.score"
						placeholder="请输入大于0的整数"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addSendScore,
	} from '@/api/marketing'
	import {
		getUserList,
	} from '@/api/user'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				loading: false,
				options: [],
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					phone: '',
					score: '',
					name: '',
					user_uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					user_uuid: [{
						required: true,
						message: '请输入用户手机号',
						trigger: 'blur'
					}],
					score: [{
						required: true,
						message: '请输入积分',
						trigger: 'blur'
					}, {
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: 1,
						name: '用户'
					},
					{
						id: 2,
						name: '管理员'
					},
				],
				areaCode: '+86',
			}
		},
		mounted() {},
		methods: {
			changeUser(e) {
				let opItem = this.options.find(item => {
					return item.uuid = e
				})
				this.addBody.name = opItem.name
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					this.getUserList(query)
				}
			},
			async getUserList(phone) {
				const {
					status,
					data
				} = await getUserList({
					phone: phone
				})
				if (status !== 200) return
				this.options = data.result.data
				this.loading = false
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().addSendScore()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addSendScore: async () => {
						const {
							status,
							data
						} = await addSendScore({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('下发成功')
					},
					editUser: async () => {
						const {
							status
						} = await editUser({
							name: this.addBody.name,
							phone: this.areaCode + '' + this.addBody.phone,
							score: this.addBody.score,
							user_uuid: this.addBody.user_uuid
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUser: async (uuid) => {
						const {
							data,
							status
						} = await getUser({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().getUser(val.uuid)
				} else {
					this.addBody.user_uuid = ''
					this.addBody.score = ''
					this.addBody.name = ''
					this.addBody.phone = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>